<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link rel="icon" type="image/png" href="favicon.png" />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <title>Restó APP</title>
    </head>
    <body class="page" style="overflow-y: scroll; height: 100vh">
      <Header :isRestoCompleto="!firstTime" ></Header>
      <div class="col-lg-8 mx-auto p-3 py-md-5">
      

        <div class="row">
    <div class="col-2"  >
      <a href="#"   @click="goToPage('Horarios', $event)" v-if="!firstTime" >
      <p class="h5 mb-2"> <b-icon-arrow-left></b-icon-arrow-left>Atrás</p>
    </a>
    </div>
    <div class="col-8">
      <h3>Imagenes</h3>
    </div>

    
    <div class="alert alert-primary" role="alert">
      Puedes cargar hasta un máximo de 10 imágenes
</div>

    <div class="col-2">
      <a href="#" v-on:click="goToPage('ImagenesMenu', $event)" v-if="!firstTime">
      <p class="h5 mb-2">Siguiente<b-icon-arrow-right></b-icon-arrow-right></p>
    </a>
    </div>
  </div>


        <hr class="" />
        <div>
          <div
            v-for="(image, index) in images"
            :key="index"
            class="mb-12 row fila"
          >
            <div class="col-sm-2">Imagen {{ index+1 }}</div>

            <div class="col-sm-3">
              <img class="imagen" :src="image.imagen" alt="" />
            </div>

            <div class="col-sm-1" style="    font-size: 30px;">
              <i class="fa fa-trash" v-on:click="borrarImagen(image.id)"></i>
            </div>
          </div>
          <hr class="" />
          <div class="mb-6 row fila d-grid d-md-flex">
            <label for="file-upload" class="btn btn-primary col-sm-2"  v-if="images.length <= 9">
              <i class="fa fa-cloud-upload"></i> Nueva Imagen
            </label>
            <div class="col-sm-2">
              <img class="imagen" :src="nuevaImagen" alt="" />
            </div>
            <input
              id="file-upload"
              @change="handleImage"
              type="file"
              accept="image/*"
              class="col-sm-4"
            />
            <div class="d-grid d-md-flex justify-content-md-center">
              <button class="btn btn-primary" @click="goToPage('Horarios', $event)" v-if="firstTime">
                Anterior
              </button>
              <button class="btn btn-primary" v-if="firstTime" @click="goToPageFirstTime('ImagenesMenu')">
                Siguiente
              </button>
            </div>
          </div>
        </div>
        <PopUp :show="success" @close="success = false;">
          <template #body>
            <p>{{ success_msg }}</p>
          </template>
        </PopUp>
        <PopUp :show="error" @close="error = false">
          <template #body>
            <p>{{ error_msg }}</p>
          </template>
        </PopUp>
      </div>

      <Footer />
    </body>
  </html>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import PopUp from "../components/PopUp.vue";
import axios from "axios";
export default {
  components: { Header, Footer, PopUp },
  data: function () {
    return {
      firstTime: false,
      images: [],
      nuevaImagen: "",
      error: false,
      error_msg: "",
      success: false,
      success_msg: "",
    };
  },
  methods: {
    handleImage(e) {

      const selectedImage = e.target.files[0];
      this.createBase64Image(selectedImage).then(() => {
        this.agregarImagen();
      })
    },

    createBase64Image(fileObject) {
      return new Promise((resolve) => {
        const reader = new FileReader();
      reader.onload = () => {
        this.nuevaImagen = reader.result;
      resolve();
      };

      reader.readAsDataURL(fileObject);
      })

    },
    agregarImagen() {
      this.error = false;
      if (this.nuevaImagen == "") {
        this.error = true;
        this.error_msg = " Primero seleccione una imagen";
        return;
      }
      let json = {
        imagen: this.nuevaImagen,
        orden: 0,
      };
      axios
        .post("/agregarImagen", json)
        .then((response) => {
          if (response.status == 200) {
            this.success = true;
            if(this.firstTime) {
              this.success_msg = "Se ha logrado guardar la imagen con exito";
            } else {
              this.success_msg = "Se ha logrado guardar la imagen con exito";
            }
            
            this.cargarImagenes();
            this.nuevaImagen = "";
          } else {
            this.error = true;
            this.error_msg =
              " No se ha podido guardar la imagen. Intente nuevemente mas tarde";
          }
        });
    },
    cancelar() {
      this.error = false;
      this.nuevaImagen = "";
    },
    borrarImagen(id) {
      this.error = false;
      let json = {
        id: id,
      };
      axios
        .post("/borrarImagen", json)
        .then((response) => {
          if (response.status == 200) {
            this.success = true;
            this.success_msg = "Se ha borrado la imagen con exito";
            this.cargarImagenes();
          } else {
            this.error = true;
            this.error_msg =
              " No se ha podido borrar la imagen. Intente nuevemente mas tarde";
          }
        });
    },
    cargarImagenes() {
      axios
        .get(
          "/imagenes/mail"
        )
        .then((data) => {
          if (data.status == 200) {
            this.images = data.data;
            console.log(data);
          }
        });
    },
    goToPageFirstTime(page) {
      this.$router.push({ name: page, params: { firstTime: true } });
    },
    goToPage(page, $event) {
      this.$router.push({ name: page});
      $event?.preventDefault();
    },
  },
  beforeMount() {
    this.cargarImagenes();
  },
};
</script>
<style >
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import "../../node_modules/vue2-timepicker/dist/VueTimepicker.css";
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

.imagen {
  max-height: 60px;
  display: block;
}

input[type="file"] {
  display: none;
}
.custom-file-upload {
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  background-color: blue;
}
.btn {
  height: 60px;
}

.fila {
  max-height: 100px;
  padding: 6px 0px;
}
:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}
body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
.btn-primary{
  margin: 15px;
}
</style>
